import Neva from "../assets/images/news/neva.png";

import Baikal1 from "../assets/images/news/baikal-1.png";
import Baikal2 from "../assets/images/news/baikal-2.png";
import Baikal3 from "../assets/images/news/baikal-3.png";

import L9g20_1 from "../assets/images/l9g20/L-9g20-1.png";
import L9g20_2 from "../assets/images/l9g20/L-9g20-2.png";
import L9g20_3 from "../assets/images/l9g20/L-9g20-3.png";
import L9g20_4 from "../assets/images/l9g20/L-9g20-4.png";

export const newsData = (t) => [
    {
      id: 1,
      title: t('news.article1.title'),
      date: t('news.article1.date'),
      excerpt: t('news.article1.excerpt'),
      image: Neva,
      images: [
        Neva 
      ],
      content: [
        { type: 'paragraph', text: t('news.article1.fullText.p1') },
        { type: 'paragraph', text: t('news.article1.fullText.p2') },
        { type: 'paragraph', text: t('news.article1.fullText.p3') },
        { type: 'paragraph', text: t('news.article1.fullText.p4') }
      ]
    },
    {
      id: 2,
      title: t('news.article2.title'),
      date: t('news.article2.date'),
      excerpt: t('news.article2.excerpt'),
      image: L9g20_1,
      images: [
        L9g20_1,
        L9g20_2,
        L9g20_3,
        L9g20_4
      ],
      content: [
        { type: 'paragraph', text: t('news.article2.fullText.p1') },
        { type: 'paragraph', text: t('news.article2.fullText.p2') },
        { type: 'paragraph', text: t('news.article2.fullText.p3') },
        { type: 'bulletList', items: [
          t('news.article2.fullText.p3_1'),
          t('news.article2.fullText.p3_2'),
          t('news.article2.fullText.p3_3'),
          t('news.article2.fullText.p3_4'),
          t('news.article2.fullText.p3_5')
        ]},
        { type: 'paragraph', text: t('news.article2.fullText.p4') }
      ]
    },
    {
      id: 3,
      title: t('news.article3.title'),
      date: t('news.article3.date'),
      excerpt: t('news.article3.excerpt'),
      image: Baikal1,
      images: [
        "https://www.jinr.ru/wp-content/uploads/2024/02/Baikal-GVD-1.jpg",
        Baikal1,
        "https://minio.nplus1.ru/app-images/757688/63f642d92db40_img_tablet.jpg",
        Baikal2,
        "https://www.jinr.ru/wp-content/uploads/2024/02/Baikal-GVD-2.jpg",
        Baikal3
      ],
       content: [
        { type: 'paragraph', text: t('news.article3.fullText.p1') },
        { type: 'paragraph', text: t('news.article3.fullText.p2') },
        { type: 'paragraph', text: t('news.article3.fullText.p3') }
      ]
    }
];
